export const SUPPORT_ACCESS_LEVEL_OPTIONS = [
  { value: 'read_only', label: 'Read only' },
  { value: 'operations', label: 'Operations' },
  { value: 'full_admin', label: 'Full admin' },
];

const STATUS_LABELS = {
  active: 'Active',
  expired: 'Expired',
  revoked: 'Revoked',
};

function parseDate(value) {
  if (!value) {
    return null;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function buildStatusLabel(status) {
  const normalized = String(status || '').trim().toLowerCase();
  return STATUS_LABELS[normalized] || STATUS_LABELS.expired;
}

function buildInviteStatusLabel(grant, now) {
  if (grant.inviteConsumedAt) {
    return 'Consumed';
  }

  const inviteExpiresAt = parseDate(grant.inviteExpiresAt);
  if (!inviteExpiresAt) {
    return 'Unavailable';
  }

  return inviteExpiresAt.getTime() <= now.getTime() ? 'Expired' : 'Pending';
}

export function normalizeSupportAccessDateTime(value) {
  const raw = String(value || '').trim();
  if (!raw) {
    return '';
  }

  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
  if (!match) {
    return '';
  }

  const [, yearValue, monthValue, dayValue, hourValue, minuteValue] = match;
  const year = Number(yearValue);
  const month = Number(monthValue);
  const day = Number(dayValue);
  const hour = Number(hourValue);
  const minute = Number(minuteValue);
  const date = new Date(raw);
  if (
    Number.isNaN(date.getTime()) ||
    date.getFullYear() !== year ||
    date.getMonth() + 1 !== month ||
    date.getDate() !== day ||
    date.getHours() !== hour ||
    date.getMinutes() !== minute
  ) {
    return '';
  }

  return date.toISOString();
}

export function validateSupportAccessGrantForm(form) {
  const errors = {};

  if (!String(form?.label || '').trim()) {
    errors.label = 'Label is required.';
  }

  if (!String(form?.accessLevel || '').trim()) {
    errors.accessLevel = 'Access level is required.';
  }

  if (!String(form?.expiresAt || '').trim()) {
    errors.expiresAt = 'Expiry is required.';
  } else if (!normalizeSupportAccessDateTime(form.expiresAt)) {
    errors.expiresAt = 'Expiry must be a valid date and time.';
  }

  if (!String(form?.reason || '').trim()) {
    errors.reason = 'Reason is required.';
  }

  return errors;
}

export function buildSupportAccessRows(dtoRows, now = new Date()) {
  return (Array.isArray(dtoRows) ? dtoRows : []).map((grant) => {
    const normalizedStatus = String(grant?.status || '').trim().toLowerCase();
    const isActive = normalizedStatus === 'active';

    return {
      id: grant.id,
      key: grant.id,
      username: grant.username,
      label: grant.label,
      accessLevel: grant.accessLevel,
      accessLevelLabel: grant.accessLevelLabel,
      status: grant.status,
      statusLabel: buildStatusLabel(grant.status),
      expiresAt: grant.expiresAt,
      inviteExpiresAt: grant.inviteExpiresAt,
      inviteConsumedAt: grant.inviteConsumedAt,
      inviteStatusLabel: buildInviteStatusLabel(grant, now),
      lastLoginAt: grant.lastLoginAt,
      createdBy: grant.createdBy,
      createdAt: grant.createdAt,
      canRevoke: isActive,
      canRegenerateInvite: isActive,
    };
  });
}
